module.exports = __webpack_public_path__ + "static/media/aywa.2cd912c4.svg";